import loadImage from 'blueimp-load-image'

import { showConfirmModal, hideReplyModalAttachmentLoader } from 'Actions/UiActions'
import { sendAttachment } from 'Actions/AttachmentsActions';
import { uploadLimits } from 'Actions/ContextInfoActions'

export class ImageUploader {

	constructor( dispatch, setAttachmentsHash ) {
		this.dispatch = dispatch;
		this.setAttachmentsHash = setAttachmentsHash;
	}

	processFiles( files, data ) {
		this.originalBlobs = [];
		this.uploadRotations = [];
		this.isInvalid = false;
		this.invalidFiles = [];
		this.files = files;
		this.data = data;

		if( files.length > 0 ) {
			this.validateFiles( this.uploadFiles )
		}
	}

	uploadFiles = () => {
		setTimeout( ()=> {
			this.uploadImages()
		}, 50 )
	};

	prepareFile = ( file, isValid ) => {
		return !( !isValid && !this.userInput( file ) );
	};

	validateFiles( callback ) {
		[ ...this.files ].forEach( file => {
			if( this.validateAttachment( file, this.prepareFile ) ) {
				this.addImage( file );
				this.convertImage( file );
			} else {
				this.isInvalid = true;
				this.invalidFiles = [ ...this.invalidFiles, file ];
			}
		}, callback() );
	}

	validateAttachment( file, callback ) {
		let size = file.size,
			extension = file.name.substr( file.name.lastIndexOf( '.' ) + 1 ).toLowerCase(),
			limits = this.dispatch( uploadLimits() ),
			isValid = true;

		if( limits && limits[ extension ] ) {
			if(
				( limits[ extension ].width > 0 && file.width > limits[ extension ].width ) ||
				( limits[ extension ].height > 0 && file.height > limits[ extension ].height ) ||
				( size > parseInt( limits[ extension ].size ) ) ||
				( !limits[ extension ].permissions )
			) {
				isValid = false;
			}
			return callback( file, isValid );
		}
	}

	addImage( file ) {
		let blob;
		if( file.byteContent ) {
			blob = new Blob( [ file.byteContent ], { type: file.type } );
		} else {
			blob = new Blob( [ file ] );
		}
		this.originalBlobs.push( {
			blob: blob,
			name: file.name
		} );
	}

	convertImage = ( file ) => {
		try {
			loadImage.parseMetaData( file, ( metaData ) => {
					if( metaData && metaData.exif ) {
						let orientation = metaData.exif.get( 'Orientation' ),
							rotation = 0;
						switch( orientation ) {
							case 3: // Upside down.
								rotation = 180;
								break;
							case 6: // 90 degrees counter-clockwise.
								rotation = 90;
								break;
							case 8: // 90 degrees clockwise.
								rotation = 270;
								break;
							default:
								break;
						}
						this.uploadRotations.push( rotation );
					} else {
						this.uploadRotations.push( 0 );
					}
				},
				{
					maxMetaDataSize: 262144,
					disableImageHead: true,
					disableExifThumbnail: true,
					disableExifSub: true,
					disableExifGps: true
				} );
		} catch( ex ) {
			this.uploadRotations.push( 0 );
		}
	};

	uploadImages = () => {
		let files = new FormData(), response;
		if( this.isInvalid ) {
			return null;
		}
		this.originalBlobs.forEach( ( file, index )=> {
			files.append( 'files[]', file.blob, file.name.replace( /(\..{3,})/ig, '_' + (new Date().getTime()) + '$1' ) );
			files.append( 'rotations[]', this.uploadRotations[ index ] );
		} );
		response = this.dispatch( sendAttachment( files, this.data ) );
		response.then( responseHash => {
			this.setAttachmentsHash( responseHash() );
		} ).catch( ( error ) => {
			topifyConsole.error( error );
			this.dispatch( hideReplyModalAttachmentLoader() );
		} );
	};

	userAnswer( file ) {
		this.isInvalid = false;
		this.addImage( file );
		this.convertImage( file );
		if( (this.invalidFiles.length - 1) === this.invalidFiles.indexOf( file ) ) {
			this.uploadFiles();
		}
	}

	userInput( file ) {
		this.dispatch( showConfirmModal( 'Re-size Warning', 'The files need to be resized\nDo you like to proceed?', this.userAnswer.bind( this, file ) ) );
	}
}

export default ImageUploader;


// WEBPACK FOOTER //
// ./src/utils/imageUploader.js